import ProgressBar from './progress-bar.element.js';

export default ProgressBar;

ProgressBar.define('wje-progress-bar', ProgressBar);
